import { IoMdPricetags } from "react-icons/io"
import { Button, ButtonLoader } from "../../components/Button"
import { ModalBody, ModalFooter, ModalHeader, ModalPanel } from "../../components/Modal"
import { FormRow, Input, Label, SelectInput } from "../../components/Form"
import TagList from "../../components/TagList"
import { CirclePickerColor } from "../../components/ColorPicker";
import './styles.scss';

export const AssistanceTagScreen = ({
  selectedAssistance,
  handleOpenModal,
  handleCloseModal,
  modalIsOpen,
  tagId,
  data,
  loading,
  handleCreateTag,
  handleRemoveTag,
  handleEditTag,
  handleLinkTag,
  handleSearchTags,
  searchTerm,
  errors,
  register,
  handleSubmit,
  handleChangeColor,
  selectedColor,
  handleSelectedTag,
  handleSelectedTagAll,
  selectedTag,
}) => {
  
  return (
    <>
      <Button
        hiddenText
        hasIcon={<IoMdPricetags size={16} />}
        label="Vincular Tag"
        handleClick={handleOpenModal}
        color="orange"
        isDisabled={!selectedAssistance || !selectedAssistance.length}
      />
      {modalIsOpen && (
        <ModalPanel modalIsOpen={modalIsOpen}>
          <ModalHeader closeModal={handleCloseModal} title={!tagId ? "Tags" : "Editar"} />
          <ModalBody>
            <div className={`${tagId ? "card-tag-edit" : "card-tag-list"}`}>
              {!tagId ? (
                <>
                  <div className="tag-filter">
                    <Input
                      placeholder={
                        data.length > 0
                          ? "Digite o nome da tag que deseja buscar"
                          : "Digite aqui o nome da tag que deseja adicionar"
                      }
                      onChange={handleSearchTags}
                      hasIcon={<i class="fi fi-rr-search" />}
                    />
                  </div>
                  <TagList
                    searchTerm={searchTerm}
                    data={data}
                    handleSelectedTag={handleSelectedTag}
                    handleSelectedTagAll={handleSelectedTagAll}
                    selectedTag={selectedTag}
                    onRemoveTag={handleRemoveTag}
                    onEditTag={handleEditTag}
                    onCreateTag={handleCreateTag}
                  />
                </>
              ) : (
                <div className="tag-input-content">
                  <FormRow>
                    <Label label="Nome" hasError={errors.name?.message} />
                    <Input
                      register={register("name", {
                        required: { value: true, message: "Campo Obrigatório" },
                      })}
                      placeholder="Digite o nome da Tag"
                      hasError={errors.name?.message}
                    />
                  </FormRow>
                  <CirclePickerColor handleChangeColor={handleChangeColor} color={selectedColor} />
                </div>
              )}
            </div>
          </ModalBody>
          <ModalFooter>
            <div className="tag-buttons">
              {tagId !== "" && (
                <Button color="danger" label="Cancelar" handleClick={() => handleCloseModal()} />
              )}
              

              {data.length ? (
                <>
                {!!tagId ? <ButtonLoader
                  color="orange"
                  messageProcess="Salvando..."
                  label="Salvar"
                  handleClick={handleSubmit}
                  loading={loading}
                /> : <ButtonLoader
                color="orange"
                messageProcess="Vinculando..."
                label="Vincular"
                handleClick={handleLinkTag}
                loading={loading}
                isDisabled={!selectedTag.length}
              />}
                </>
              ) : (
                <ButtonLoader
                  color="orange"
                  label="Criar nova tag"
                  messageProcess="Criando tags..."
                  handleClick={handleCreateTag}
                  loading={loading}
                />
              )}
            </div>
          </ModalFooter>
        </ModalPanel>
      )}
    </>
  )
}